import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function ChangelogPage() {
 return (
  <StaticPageLayout title='Changelog'>
   <div className='space-y-12 relative border-l border-border/50 ml-4'>
    <div className='pl-8 relative'>
     <div className='absolute left-[-5px] top-2 w-2.5 h-2.5 bg-primary rounded-full' />
     <h2 className='text-2xl font-bold mb-2'>v2.0.4 - BETA</h2>
     <div className='text-xs font-mono text-primary mb-4'>CURRENT RELEASE</div>
     <ul className='list-disc pl-4 space-y-2 text-muted-foreground'>
      <li>
       Implemented new "Industrial" Design System across all UI components.
      </li>
      <li>Added Resume Parsing pipeline with OCR support.</li>
      <li>Refactored Onboarding Flow for smoother user experience.</li>
      <li>Improved latency for voice synthesis by 40%.</li>
     </ul>
    </div>

    <div className='pl-8 relative'>
     <div className='absolute left-[-5px] top-2 w-2.5 h-2.5 bg-muted rounded-full' />
     <h2 className='text-2xl font-bold mb-2'>v1.5.0</h2>
     <div className='text-xs font-mono text-muted-foreground mb-4'>
      RELEASED: JAN 2024
     </div>
     <ul className='list-disc pl-4 space-y-2 text-muted-foreground'>
      <li>Initial launch of Behavioral Interview module.</li>
      <li>Added GitHub integration for portfolio analysis.</li>
      <li>Dark mode support.</li>
     </ul>
    </div>
   </div>
  </StaticPageLayout>
 );
}
